var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-bottom",style:(_vm.elStyle)},[_c('a',{staticClass:"m-bottom__bp",style:(_vm.aStyle),on:{"click":_vm.onDownload}})])
}
var staticRenderFns = []

export { render, staticRenderFns }